import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { enableMocking } from './mocks'
import { queryClient } from './lib/queryClient'
import { logAppVersion } from './utils/logAppVersion'
import { initRum } from './lib/datadogRum'
import packageJson from '../package.json'
import './index.css'

logAppVersion('backoffice-ui', import.meta.env.VITE_TAG)
logAppVersion('@linearb/buzz', packageJson.dependencies['@linearb/buzz'])
logAppVersion(
  '@linearb/gitstream-core-js',
  packageJson.dependencies['@linearb/gitstream-core-js']
)

initRum()

enableMocking().then(() => {
  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root element not found')
  }
  const root = createRoot(container)

  root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  )
})
